import React from 'react';
import { Button, ButtonProps, Spinner } from 'react-bootstrap';

const FormikSubmit: React.FunctionComponent<{ className?: string; loading: boolean; text: string } & ButtonProps> = ({
  className,
  loading,
  text,
  ...buttonProps
}) => (
  <Button
    type="submit"
    className={className}
    style={{ minWidth: '100px' }}
    {...buttonProps}
    disabled={loading || buttonProps.disabled}
  >
    {loading ? <Spinner animation="border" size="sm" /> : text}
  </Button>
);

export default FormikSubmit;
